import { AppDispatch } from '@bonanza-social/toolkit/state';
import { findAddress, retrieveAddress } from '@bonanza-social/toolkit/api';
import { FullAddress } from '../components/AddressField/AddressField.types';

export const fetchFullAddress = async (
  dispatch: AppDispatch,
  query: string,
): Promise<FullAddress | null> => {
  try {
    const foundAddresses = await fetchAddresses(dispatch, query);
    if (!foundAddresses?.length) {
      console.warn('Address not found.');
      return null;
    }

    const retrievedAddresses = await retrieveFullAddresses(
      dispatch,
      foundAddresses[0].Id,
    );
    if (!retrievedAddresses?.length) {
      console.warn('No full address found.');
      return null;
    }

    return retrievedAddresses[0];
  } catch (err) {
    console.error('Error fetching address:', err);
    return null;
  }
};

const fetchAddresses = async (
  dispatch,
  query: string,
): Promise<unknown[] | null> => {
  const { payload: foundAddresses } = await dispatch(findAddress({ query }));
  return foundAddresses?.Items || null;
};

const retrieveFullAddresses = async (
  dispatch,
  addressId: string,
): Promise<unknown[] | null> => {
  const { payload: retrievedFullAddress } = await dispatch(
    retrieveAddress(addressId),
  );
  return retrievedFullAddress?.Items || null;
};
